var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.relationsNetworkMenuClassNames }, [
    _c(
      "div",
      {
        staticClass: "relations-network-menu__item blue-red-hover-text",
        on: { click: _vm.resetDefault },
      },
      [
        _c("i", { staticClass: "uk-icon-refresh" }),
        _vm._v(" "),
        _c("span", [_vm._v("Сбросить")]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "relations-network-menu__item blue-red-hover-text",
        on: { click: _vm.showRelationsAsList },
      },
      [
        _c("i", { staticClass: "uk-icon-file-text-o" }),
        _vm._v(" "),
        _c("span", [_vm._v("Список")]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "relations-network-menu__item blue-red-hover-text",
        on: { click: _vm.toggleFullScreen },
      },
      [
        _vm.fullscreen
          ? [
              _c("i", { staticClass: "uk-icon-compress" }),
              _vm._v(" "),
              _c("span", [_vm._v("Свернуть")]),
            ]
          : [
              _c("i", { staticClass: "uk-icon-arrows-alt" }),
              _vm._v(" "),
              _c("span", [_vm._v("На весь экран")]),
            ],
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "relations-network-menu__item blue-red-hover-text",
        on: { click: _vm.printImage },
      },
      [
        _c("i", { staticClass: "uk-icon-print" }),
        _vm._v(" "),
        _c("span", [_vm._v("Распечатать")]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "relations-network-menu__item blue-red-hover-text",
        on: { click: _vm.downloadImage },
      },
      [
        _c("i", { staticClass: "uk-icon-save" }),
        _vm._v(" "),
        _c("span", [_vm._v("Сохранить")]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "relations-network-menu__item blue-red-hover-text",
        on: { click: _vm.toggleLegend },
      },
      [
        !_vm.showLegend
          ? _c("span", [_vm._v("Показать легенду")])
          : _c(
              "span",
              {
                staticStyle: {
                  width: "153px",
                  display: "inline-block",
                  "text-align": "right",
                },
              },
              [_vm._v("Скрыть легенду")]
            ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }